module.exports = __webpack_public_path__ + "img/5.817f959e.jpg";